import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth.js'
import menu from './modules/menu.js'
import account from "./modules/account";
import project from "./modules/project";
import transaction_categories from "./modules/transaction_categories";
import transaction from "./modules/transaction";
import income_statement from "./modules/income_statement";
import dashboard from "./modules/dashboard";
import balance_sheet from "./modules/balance_sheet";

Vue.use(Vuex);

let defaultState = {
    modules: {
        auth,
        menu,
        account,
        project,
        transaction_categories,
        transaction,
        income_statement,
        dashboard,
        balance_sheet
    },
    state: {
        isLoading: false
    }
}

export default new Vuex.Store(defaultState);